import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  ClientAreaSkeleton,
} from './ClientAreaSkeleton';
import './Skeleton.css';

const stripTrailingSlash = (pathname) => pathname.replace(/\/+$/, '') || '/';

const resolveClientVariant = (pathname) => {
  // /ecotrim y /ecotrim/ son la landing pública (IT-1111), no el simulador:
  // al recargar no deben aparecer los skeletons del área cliente.
  if (stripTrailingSlash(pathname) === '/ecotrim') return null;

  if (pathname.startsWith('/mi-area')) {
    if (pathname.includes('/perfil')) return 'profile';
    if (pathname.includes('/compras') || pathname.includes('/suscripcion') || pathname.includes('/equipo')) {
      return 'table';
    }
    return 'tools';
  }

  if (pathname.startsWith('/ecotrim-area')) {
    if (pathname.includes('/simulaciones')) return 'simulations';
    if (pathname.includes('/proyectos') || pathname.includes('/proyecto')) return 'projects';
    if (pathname.includes('/datadis') || pathname.includes('/recursos') || pathname.includes('/optrim')) {
      return 'panel';
    }
    return 'dashboard';
  }

  if (pathname.startsWith('/ecotrim')) {
    if (pathname.includes('/catalog')) return 'panel';
    return 'simulator';
  }

  return null;
};

/**
 * Fallback de Suspense: skeleton del área cliente según la ruta,
 * o un fondo suave sin texto en páginas públicas (evita el flash “Cargando…”).
 */
const RouteSuspenseFallback = () => {
  const { pathname } = useLocation();
  const variant = resolveClientVariant(pathname);

  if (variant) {
    return <ClientAreaSkeleton variant={variant} />;
  }

  if (pathname.startsWith('/login') || pathname.startsWith('/register')) {
    return (
      <div className="page-skeleton-login" role="status" aria-busy="true">
        <div className="page-skeleton-login-card">
          <span className="sk-bone" style={{ width: 64, height: 64, borderRadius: 16 }} />
          <span className="sk-bone" style={{ width: 260, height: 28 }} />
          <span className="sk-bone" style={{ width: '100%', height: 44, borderRadius: 10, marginTop: 24 }} />
          <span className="sk-bone" style={{ width: '100%', height: 44, borderRadius: 10 }} />
          <span className="sk-bone" style={{ width: '100%', height: 48, borderRadius: 10, marginTop: 12 }} />
        </div>
      </div>
    );
  }

  return <div className="page-skeleton-soft" role="status" aria-busy="true" />;
};

export default RouteSuspenseFallback;
export { resolveClientVariant };
